import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  dataInRequest,
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/pitStopJustificativa/actions';

import Form from './form';

function PitStopJustificativa() {
  const redux = useSelector((state) => state.pitStopJustificativa);

  const options = useMemo(
    () => [
      { label: 'L', value: t('s.geral.opcoes.liberado') },
      { label: 'B', value: t('s.geral.opcoes.bloqueado') },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'tipoatendimentostr',
        label: t('s.cadastro.pitstop.atendimentos'),
        filter: { type: 'text' },
      },
      {
        id: 'descricaoobservacao',
        label: t('s.cadastro.pitstop.descricaoobservacao'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const fieldlist = ['tipoatendimentostr', 'descricaoobservacao'];

  const substituirHeader = {
    tipoatendimentostr: t('s.cadastro.pitstop.atendimentos'),
    descricaoobservacao: t('s.cadastro.pitstop.descricaoobservacao'),
  };

  return (
    <UnidataTable
      fixed
      //  title={t('s.menu.configuracao.pitstop.justificativa')}
      redux={redux}
      header={header}
      read={dataInRequest}
      find={findData}
      remove={deleteData}
      form={Form}
      keys="idobservacaoatendimento"
      detach="idobservacaoatendimento"
      pdf
      excel
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'observacaoatendimento/justificativa',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: t('s.menu.configuracao.pitstop.justificativa'),
          substituirValores: {},
        })
      }
    />
  );
}

export default PitStopJustificativa;
